import { endOfMonth, parseISO } from 'date-fns'

export const selectTransactions = (state) => {
  const topUps = state.billingData.creditTopUps.map((topUp) => ({
    id: `topUp-${topUp.id}`,
    originalId: topUp.id,
    date: topUp.paidAt || '9999999999999',
    type: 'credit',
    amount: Number(topUp.amountLocalCurrency),
    hasPdf: topUp.hasPdf,
    hasStripeReceipt: topUp.hasStripeReceipt,
    notes: topUp.notes,
    className: topUp.paidAt ? 'green-row' : '',
  }))

  const usages = state.billingData.creditUsages.map((usage) => ({
    id: `usage-${usage.month}`,
    date: endOfMonth(parseISO(usage.month)).toISOString(),
    month: usage.month,
    type: 'debit',
    amount: Number(usage.amountLocalCurrency),
    monthly: true,
  }))

  return [...topUps, ...usages]
}
